import { render } from "./Verification_scope.vue?vue&type=template&id=67e2b60a"
import script from "./Verification_scope.vue?vue&type=script&lang=js"
export * from "./Verification_scope.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__